export const ALL_EXAMPLES_CATEGORY_ID = undefined;

export const ALL_EXAMPLES_CATEGORY = {
    id: ALL_EXAMPLES_CATEGORY_ID,
    title: 'All',
    path: '/press-release-examples',
};
